import { useQuery, QueryResult } from '@eika-infrastruktur/react-query';

import { CrossBorderPaymentsStatus } from '../generated-types';
import { getStatus } from '../services/crossBorderPaymentsService';

export const useCrossBorderStatus = (): QueryResult<CrossBorderPaymentsStatus> =>
    useQuery({
        queryKey: ['status'],
        queryFn: getStatus,
    });
